import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pb-home',
  templateUrl: './pb-home.component.html',
  styleUrls: ['./pb-home.component.scss']
})
export class PbHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
